export default "__VITE_ASSET__nfpNheto__"